import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

import user from './user'
import promo from './promo'
import shared from './shared'
import auth from './auth'
import games from './game'
import team from './team'
import segment from './segment'
import channels from './channels'
import advancedFeatures from './advancedFeatures'
import products from './products'
import promotion from './promotion'
import resources from './resources'
import media from './media'
import finances from './finances'
import awarenessLoyalty from './awareness&loyalty'
import monthSales from './monthSales'
import sales from './sales'
import insights from './insights'

Vue.use(Vuex)
Vue.use(VueAxios, axios)

export default new Vuex.Store({
	modules: {
		user, shared, promo, auth, games, team,
    segment, channels, advancedFeatures, products,
    promotion, resources, media, finances, awarenessLoyalty,
    monthSales, sales, insights
	}
})
  /* state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  } */

